import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { RootState } from "../../../store/rootReducer";
import { allowSave, Option } from "../../../store/helpers";
import { showModal } from "../../../reducers/modal/modal.actions";
import { updatePartner } from "../../../reducers/dokumenKerjasama/dokumenKerjasama.actions";
import { fieldErrorMessage, fieldHasErrors } from "../../../store/errorHandler";
import { PermissionMenuName } from "../../../interfaces/UserRole";

export const FormPartner = () => {
  const dispatch = useDispatch();
  
  const errors = useSelector((state: RootState) => state.dokumenKerjasama.error);
  const listPartner = useSelector((state: RootState) => state.partner.listPartner);
  const isLoading = useSelector((state: RootState) => state.dokumenKerjasama.isLoading);
  const listIdPartner = useSelector((state: RootState) => state.dokumenKerjasama.selectedDokumenKerjasama?.CO_ID);
  const listDetailPartner = useSelector((state: RootState) => state.dokumenKerjasama.selectedDokumenKerjasama?.CO_DETAIL);
  const [pelaksanaOptions, setPartnerOptions] = useState<Option[]>([]);
  const [selectedPartner, setSelectedPartner] = useState<Option | null>(null);

  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS);
  const canSave = allowSave(role, 2);

  const onChangePartner = (e: Option | null) => {
    setSelectedPartner(e);
  }

  const addNewPartner = () => {
    if (!selectedPartner || !listIdPartner || typeof listDetailPartner === 'undefined' || typeof listIdPartner === 'undefined') {
      dispatch(showModal(
        'Partner gagal ditambahkan',
        'Mohon pilih partner terlebih dahulu.'
      ));
      return;
    }

    if (typeof listIdPartner.find((search) => search === parseInt(selectedPartner.value)) !== 'undefined') {
      dispatch(showModal(
        'Partner gagal ditambahkan',
        'Partner sudah terdaftar sebagai partner dalam dokumen kerjasama ini.'
      ));
      return;
    }

    const newPartner = listPartner.find((search) => search.CO_ID === parseInt(selectedPartner.value));

    if (newPartner) {
      const newPartnerIdList = [...listIdPartner];
      const newPartnerDetailList = [...listDetailPartner];
      newPartnerIdList.push(newPartner.CO_ID);
      newPartnerDetailList.push(newPartner);
      dispatch(updatePartner(newPartnerIdList, newPartnerDetailList));
    }
  }

  const removePartner = (id: number) => {
    if (!listIdPartner || typeof listDetailPartner === 'undefined' || typeof listIdPartner === 'undefined') {
      dispatch(showModal(
        'Partner gagal dihapus',
        'Sistem belum berhasil memuat data. Mohon coba kembali dalam beberapa saat.'
      ));
      return;
    }

    const newPartnerIdList = [...listIdPartner];
    const newPartnerDetailList = [...listDetailPartner];
    const removeTargetId = newPartnerIdList.findIndex((search) => search === id);
    const removeTargetList = newPartnerDetailList.findIndex((search) => search.CO_ID === id);

    newPartnerIdList.splice(removeTargetId, 1);
    newPartnerDetailList.splice(removeTargetList, 1);

    dispatch(updatePartner(newPartnerIdList, newPartnerDetailList));
  }

  useEffect(() => {
    const newOptions: Option[] = [];
    listPartner.forEach(item => {
      newOptions.push({
        value: item.CO_ID.toString(),
        label: item.CO_NAME
      });
    });
    setPartnerOptions(newOptions);
  }, [listPartner])

  const renderPartnerKerjasama = () => {
    if (listDetailPartner?.length === 0) {
      return (
        <tr>
          <td colSpan={2} style={{textAlign: 'center'}}>
            Data tidak ditemukan, silahkan tambah anggota baru.
          </td>
        </tr>
      );
    }

    return listDetailPartner?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item.CO_NAME}</td>
          <th>
            <button className="btn btn-danger btn-xs" disabled={isLoading || !canSave} onClick={() => removePartner(item.CO_ID)}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      );
    });
  }

  if (typeof listDetailPartner === 'undefined') return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Partner Kerjasama</h3>
        </div>
        <div className="box-body">
          Sedang memuat data...
        </div>
        <div className="overlay active">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Partner Kerjasama</h3>
        </div>
        <div className="box-body">
          <div className={`form-group ${fieldHasErrors('CO_ID', errors) ? 'has-error' : ''}`}>
            <label>Pilih Nama Partner Kerjasama</label>
            <div className="input-group">
              <Select
                isDisabled={isLoading || !canSave}
                value={selectedPartner}
                options={pelaksanaOptions}
                onChange={onChangePartner}
                menuPortalTarget={document.querySelector("body")}
              />
              <span className="input-group-btn">
                <button type="button" className="btn btn-primary" disabled={isLoading || !canSave} onClick={addNewPartner}>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <span className="help-block">{ fieldErrorMessage('CO_ID', errors) }</span>
          </div>
        </div>
        <div className="box-body table-responsive no-padding" style={{ maxHeight: '200px' }}>
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="sticky">Nama <span className="text-red"><b>*</b></span></th>
                <th className="sticky"></th>
              </tr>
            </thead>
            <tbody>
              {renderPartnerKerjasama()}
            </tbody>
          </table>
        </div>
        <div className={`overlay ${isLoading ? 'active' : null}`}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
};
